import React from "react";
import EvacuadosPorProvinciaTmp from '../../../containers/EvacuadosPorProvincia';
import { CAMPAIGN_2025 } from '../../../constants';

const EvacuadosPorProvincia = () => {

  return <EvacuadosPorProvinciaTmp campaign={CAMPAIGN_2025} year={2025}/>;
};

export default EvacuadosPorProvincia;
